/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AcademyResponse } from '../model/models';
import { CertificatesResponse } from '../model/models';
import { CertificationsResponse } from '../model/models';
import { DaysResponse } from '../model/models';
import { DeadlineResponse } from '../model/models';
import { DeadlinesResponse } from '../model/models';
import { DefaultError } from '../model/models';
import { DueDiligenceResponse } from '../model/models';
import { FeaturedResponse } from '../model/models';
import { MandatoryCoursesStatisticsResponse } from '../model/models';
import { MatrixType } from '../model/models';
import { PaginatedUsersResponse } from '../model/models';
import { SatisfactionQuizzesResponse } from '../model/models';
import { SupportRequest } from '../model/models';
import { UserAlertsResponse } from '../model/models';
import { UserCertificationCoursesResponse } from '../model/models';
import { UserCertificationIntegrityRequirementsOpenResponse } from '../model/models';
import { UserCertificationIntegrityRequirementsResponse } from '../model/models';
import { UserCertificationMulticoursesResponse } from '../model/models';
import { UserCertificationStatusResponse } from '../model/models';
import { UserCertificationsWithStatusResponse } from '../model/models';
import { UserChildrenResponse } from '../model/models';
import { UserEducationResponse } from '../model/models';
import { UserEducationalPathResponse } from '../model/models';
import { UserHomePathsResponse } from '../model/models';
import { UserMenuPathsResponse } from '../model/models';
import { UserRefreshTrainingCoursesReportResponse } from '../model/models';
import { UserRegistry } from '../model/models';
import { UserRequest } from '../model/models';
import { UserResponse } from '../model/models';
import { UserStatus } from '../model/models';
import { UsersResponse } from '../model/models';
import { ValidationError } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class UsersService {

    protected basePath = 'https://api.campusframework.test';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Accept certification integrity requirements
     * @param certificationId The id of the certification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public acceptCertificationIntegrityRequirements(certificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationIntegrityRequirementsResponse>;
    public acceptCertificationIntegrityRequirements(certificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationIntegrityRequirementsResponse>>;
    public acceptCertificationIntegrityRequirements(certificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationIntegrityRequirementsResponse>>;
    public acceptCertificationIntegrityRequirements(certificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling acceptCertificationIntegrityRequirements.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.patch<UserCertificationIntegrityRequirementsResponse>(`${this.configuration.basePath}/users/current/certifications/${encodeURIComponent(String(certificationId))}/integrity-requirements`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Accept certification integrity requirements
     * @param certificationId The id of the certification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public acceptCertificationIntegrityRequirementsOpen(certificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationIntegrityRequirementsOpenResponse>;
    public acceptCertificationIntegrityRequirementsOpen(certificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationIntegrityRequirementsOpenResponse>>;
    public acceptCertificationIntegrityRequirementsOpen(certificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationIntegrityRequirementsOpenResponse>>;
    public acceptCertificationIntegrityRequirementsOpen(certificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling acceptCertificationIntegrityRequirementsOpen.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationIntegrityRequirementsOpenResponse>(`${this.configuration.basePath}/users/current/certifications/${encodeURIComponent(String(certificationId))}/integrity-requirements/open`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create teacher CF
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTeacherRole(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserResponse>;
    public addTeacherRole(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserResponse>>;
    public addTeacherRole(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserResponse>>;
    public addTeacherRole(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling addTeacherRole.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<UserResponse>(`${this.configuration.basePath}/teachers-apb/${encodeURIComponent(String(userId))}`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certification courses
     * @param certificationId The id of the certification
     * @param courseType filter by course type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentUserCertificationCourses(certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>;
    public currentUserCertificationCourses(certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>>;
    public currentUserCertificationCourses(certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>>;
    public currentUserCertificationCourses(certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling currentUserCertificationCourses.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (courseType !== undefined && courseType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>courseType, 'course_type');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>(`${this.configuration.basePath}/users/current/certifications/${encodeURIComponent(String(certificationId))}/courses`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certification status
     * @param certificationId The id of the certification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentUserCertificationStatus(certificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationStatusResponse>;
    public currentUserCertificationStatus(certificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationStatusResponse>>;
    public currentUserCertificationStatus(certificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationStatusResponse>>;
    public currentUserCertificationStatus(certificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling currentUserCertificationStatus.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationStatusResponse>(`${this.configuration.basePath}/users/current/certifications/${encodeURIComponent(String(certificationId))}/status`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certifications
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentUserCertifications(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CertificationsResponse>;
    public currentUserCertifications(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CertificationsResponse>>;
    public currentUserCertifications(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CertificationsResponse>>;
    public currentUserCertifications(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CertificationsResponse>(`${this.configuration.basePath}/users/current/certifications`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certifications with status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentUserCertificationsWithStatus(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationsWithStatusResponse>;
    public currentUserCertificationsWithStatus(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationsWithStatusResponse>>;
    public currentUserCertificationsWithStatus(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationsWithStatusResponse>>;
    public currentUserCertificationsWithStatus(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationsWithStatusResponse>(`${this.configuration.basePath}/users/current/certifications/status`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce le scadenze dell\&#39;utente
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deadlines(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeadlinesResponse>;
    public deadlines(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeadlinesResponse>>;
    public deadlines(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeadlinesResponse>>;
    public deadlines(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DeadlinesResponse>(`${this.configuration.basePath}/deadlines`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download classroom course certificate of user
     * @param userId The id of the user
     * @param certificationId The id of the certification
     * @param courseId The id of the classroom course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadClassroomCourseCertificatePdfForUser(userId: number, certificationId: number, courseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<Blob>;
    public downloadClassroomCourseCertificatePdfForUser(userId: number, certificationId: number, courseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpResponse<Blob>>;
    public downloadClassroomCourseCertificatePdfForUser(userId: number, certificationId: number, courseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpEvent<Blob>>;
    public downloadClassroomCourseCertificatePdfForUser(userId: number, certificationId: number, courseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling downloadClassroomCourseCertificatePdfForUser.');
        }
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling downloadClassroomCourseCertificatePdfForUser.');
        }
        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling downloadClassroomCourseCertificatePdfForUser.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/${encodeURIComponent(String(certificationId))}/${encodeURIComponent(String(courseId))}/classroom-course-certificate-pdf`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download educational path pdf for user
     * @param userId The id of the user
     * @param path filter by path
     * @param completionYear filter by completion year
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadEducationalPathForUser(userId: number, path?: number, completionYear?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<Blob>;
    public downloadEducationalPathForUser(userId: number, path?: number, completionYear?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpResponse<Blob>>;
    public downloadEducationalPathForUser(userId: number, path?: number, completionYear?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpEvent<Blob>>;
    public downloadEducationalPathForUser(userId: number, path?: number, completionYear?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling downloadEducationalPathForUser.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (completionYear !== undefined && completionYear !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>completionYear, 'completion_year');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/educational-path/download-pdf`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download online course certificate of user
     * @param userId The id of the user
     * @param certificationId The id of the certification
     * @param onlineCourseId The id of the online course
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadOnlineCourseCertificatePdfForUser(userId: number, certificationId: number, onlineCourseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<Blob>;
    public downloadOnlineCourseCertificatePdfForUser(userId: number, certificationId: number, onlineCourseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpResponse<Blob>>;
    public downloadOnlineCourseCertificatePdfForUser(userId: number, certificationId: number, onlineCourseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<HttpEvent<Blob>>;
    public downloadOnlineCourseCertificatePdfForUser(userId: number, certificationId: number, onlineCourseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling downloadOnlineCourseCertificatePdfForUser.');
        }
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling downloadOnlineCourseCertificatePdfForUser.');
        }
        if (onlineCourseId === null || onlineCourseId === undefined) {
            throw new Error('Required parameter onlineCourseId was null or undefined when calling downloadOnlineCourseCertificatePdfForUser.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/${encodeURIComponent(String(certificationId))}/${encodeURIComponent(String(onlineCourseId))}/online-course-certificate-pdf`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get education
     * @param userId The id of the user
     * @param matrix filter by matrix
     * @param path filter by path
     * @param courseType filter by course type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public education(userId: number, matrix: MatrixType, path?: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserEducationResponse>;
    public education(userId: number, matrix: MatrixType, path?: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserEducationResponse>>;
    public education(userId: number, matrix: MatrixType, path?: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserEducationResponse>>;
    public education(userId: number, matrix: MatrixType, path?: number, courseType?: 'classroom' | 'online' | 'multicourse', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling education.');
        }
        if (matrix === null || matrix === undefined) {
            throw new Error('Required parameter matrix was null or undefined when calling education.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (matrix !== undefined && matrix !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>matrix, 'matrix');
        }
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (courseType !== undefined && courseType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>courseType, 'course_type');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserEducationResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/education`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get educational path
     * @param userId The id of the user
     * @param path filter by path
     * @param completionYear filter by completion year
     * @param autocomplete filter by main string field
     * @param sort sort the results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public educationalPath(userId: number, path?: number, completionYear?: number, autocomplete?: string, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserEducationalPathResponse>;
    public educationalPath(userId: number, path?: number, completionYear?: number, autocomplete?: string, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserEducationalPathResponse>>;
    public educationalPath(userId: number, path?: number, completionYear?: number, autocomplete?: string, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserEducationalPathResponse>>;
    public educationalPath(userId: number, path?: number, completionYear?: number, autocomplete?: string, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling educationalPath.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (path !== undefined && path !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>path, 'path');
        }
        if (completionYear !== undefined && completionYear !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>completionYear, 'completion_year');
        }
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (sort !== undefined && sort !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sort, 'sort');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserEducationalPathResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/educational-path`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get educational path certificates
     * @param userId The id of the user
     * @param completionYear filter by completion year
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public educationalPathCertificates(userId: number, completionYear?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CertificatesResponse>;
    public educationalPathCertificates(userId: number, completionYear?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CertificatesResponse>>;
    public educationalPathCertificates(userId: number, completionYear?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CertificatesResponse>>;
    public educationalPathCertificates(userId: number, completionYear?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling educationalPathCertificates.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (completionYear !== undefined && completionYear !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>completionYear, 'completion_year');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CertificatesResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/educational-path/certificates`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export users
     * @param user filter by user
     * @param autocomplete filter by main string field
     * @param canBeImpersonated filter by can be impersonated
     * @param registry filter by registry
     * @param status filter by status
     * @param positions filter by positions
     * @param segments filter by segments
     * @param network filter by network
     * @param networks filter by networks
     * @param statuses filter by status
     * @param area filter by area
     * @param positionsName filter by positions name
     * @param editionSupervisor returns users without cono filter except the given id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportUsers(user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<Blob>;
    public exportUsers(user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpResponse<Blob>>;
    public exportUsers(user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<HttpEvent<Blob>>;
    public exportUsers(user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (canBeImpersonated !== undefined && canBeImpersonated !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>canBeImpersonated, 'can_be_impersonated');
        }
        if (registry !== undefined && registry !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>registry, 'registry');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (positions) {
            positions.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'positions[]');
            })
        }
        if (segments) {
            segments.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'segments[]');
            })
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }
        if (networks) {
            networks.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'networks[]');
            })
        }
        if (statuses) {
            statuses.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'statuses[]');
            })
        }
        if (area !== undefined && area !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>area, 'area');
        }
        if (positionsName) {
            positionsName.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'positions_name[]');
            })
        }
        if (editionSupervisor !== undefined && editionSupervisor !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>editionSupervisor, 'edition_supervisor');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/users/export`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce ultimi alert, news e documenti mediateca inserite
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public featured(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<FeaturedResponse>;
    public featured(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<FeaturedResponse>>;
    public featured(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<FeaturedResponse>>;
    public featured(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<FeaturedResponse>(`${this.configuration.basePath}/featured`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all users
     * @param page The page to load
     * @param user filter by user
     * @param autocomplete filter by main string field
     * @param canBeImpersonated filter by can be impersonated
     * @param registry filter by registry
     * @param status filter by status
     * @param positions filter by positions
     * @param segments filter by segments
     * @param network filter by network
     * @param networks filter by networks
     * @param statuses filter by status
     * @param area filter by area
     * @param positionsName filter by positions name
     * @param editionSupervisor returns users without cono filter except the given id
     * @param sort sort the results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllUsers(page?: number, user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedUsersResponse>;
    public getAllUsers(page?: number, user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedUsersResponse>>;
    public getAllUsers(page?: number, user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedUsersResponse>>;
    public getAllUsers(page?: number, user?: number, autocomplete?: string, canBeImpersonated?: boolean, registry?: UserRegistry, status?: UserStatus, positions?: Array<number>, segments?: Array<number>, network?: number, networks?: Array<number>, statuses?: Array<UserStatus>, area?: string, positionsName?: Array<string>, editionSupervisor?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (canBeImpersonated !== undefined && canBeImpersonated !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>canBeImpersonated, 'can_be_impersonated');
        }
        if (registry !== undefined && registry !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>registry, 'registry');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (positions) {
            positions.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'positions[]');
            })
        }
        if (segments) {
            segments.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'segments[]');
            })
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }
        if (networks) {
            networks.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'networks[]');
            })
        }
        if (statuses) {
            statuses.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'statuses[]');
            })
        }
        if (area !== undefined && area !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>area, 'area');
        }
        if (positionsName) {
            positionsName.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'positions_name[]');
            })
        }
        if (editionSupervisor !== undefined && editionSupervisor !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>editionSupervisor, 'edition_supervisor');
        }
        if (sort !== undefined && sort !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>sort, 'sort');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PaginatedUsersResponse>(`${this.configuration.basePath}/users`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Due diligence
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDueDiligenceCourses(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DueDiligenceResponse>;
    public getDueDiligenceCourses(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DueDiligenceResponse>>;
    public getDueDiligenceCourses(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DueDiligenceResponse>>;
    public getDueDiligenceCourses(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DueDiligenceResponse>(`${this.configuration.basePath}/due-diligence`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get home paths
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public homePaths(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserHomePathsResponse>;
    public homePaths(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserHomePathsResponse>>;
    public homePaths(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserHomePathsResponse>>;
    public homePaths(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling homePaths.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserHomePathsResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/home-paths`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get mandatory courses
     * @param completed filter by completed
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mangatoryCourses(completed?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserEducationResponse>;
    public mangatoryCourses(completed?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserEducationResponse>>;
    public mangatoryCourses(completed?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserEducationResponse>>;
    public mangatoryCourses(completed?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (completed !== undefined && completed !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>completed, 'completed');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserEducationResponse>(`${this.configuration.basePath}/users/current/mandatory-courses`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get mandatory courses statistics
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mangatoryCoursesStatistics(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<MandatoryCoursesStatisticsResponse>;
    public mangatoryCoursesStatistics(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<MandatoryCoursesStatisticsResponse>>;
    public mangatoryCoursesStatistics(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<MandatoryCoursesStatisticsResponse>>;
    public mangatoryCoursesStatistics(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<MandatoryCoursesStatisticsResponse>(`${this.configuration.basePath}/users/current/mandatory-courses/statistics`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get menu paths
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public menuPaths(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserMenuPathsResponse>;
    public menuPaths(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserMenuPathsResponse>>;
    public menuPaths(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserMenuPathsResponse>>;
    public menuPaths(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling menuPaths.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserMenuPathsResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/menu-paths`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get next classroom courses
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public nextClassroomCourses(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DaysResponse>;
    public nextClassroomCourses(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DaysResponse>>;
    public nextClassroomCourses(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DaysResponse>>;
    public nextClassroomCourses(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling nextClassroomCourses.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DaysResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/next-classroom-courses`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get next final reviews
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public nextFinalReviews(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DaysResponse>;
    public nextFinalReviews(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DaysResponse>>;
    public nextFinalReviews(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DaysResponse>>;
    public nextFinalReviews(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling nextFinalReviews.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DaysResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/next-final-reviews`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get next online courses
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public nextOnlineCourses(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeadlineResponse>;
    public nextOnlineCourses(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeadlineResponse>>;
    public nextOnlineCourses(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeadlineResponse>>;
    public nextOnlineCourses(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling nextOnlineCourses.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DeadlineResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/next-online-courses`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get satisfaction quizzes
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public nextSatisfactionQuizzes(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<SatisfactionQuizzesResponse>;
    public nextSatisfactionQuizzes(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<SatisfactionQuizzesResponse>>;
    public nextSatisfactionQuizzes(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<SatisfactionQuizzesResponse>>;
    public nextSatisfactionQuizzes(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling nextSatisfactionQuizzes.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<SatisfactionQuizzesResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/next-satisfaction-quizzes`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Refresh training courses report
     * @param userId The id of the user
     * @param reload Reload the data without cache
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshTrainingCoursesReport(userId: number, reload?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserRefreshTrainingCoursesReportResponse>;
    public refreshTrainingCoursesReport(userId: number, reload?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserRefreshTrainingCoursesReportResponse>>;
    public refreshTrainingCoursesReport(userId: number, reload?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserRefreshTrainingCoursesReportResponse>>;
    public refreshTrainingCoursesReport(userId: number, reload?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling refreshTrainingCoursesReport.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (reload !== undefined && reload !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>reload, 'reload');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserRefreshTrainingCoursesReportResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/refresh-training-courses-report`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete teacher CF
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeTeacherRole(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public removeTeacherRole(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public removeTeacherRole(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public removeTeacherRole(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling removeTeacherRole.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/teachers-apb/${encodeURIComponent(String(userId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Info for courses belong to third party company
     * @param thirdPartyCompanyId The id of the thirdPartyCompany
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public showCoursesByThirdPartyCompanyId(thirdPartyCompanyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AcademyResponse>;
    public showCoursesByThirdPartyCompanyId(thirdPartyCompanyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AcademyResponse>>;
    public showCoursesByThirdPartyCompanyId(thirdPartyCompanyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AcademyResponse>>;
    public showCoursesByThirdPartyCompanyId(thirdPartyCompanyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (thirdPartyCompanyId === null || thirdPartyCompanyId === undefined) {
            throw new Error('Required parameter thirdPartyCompanyId was null or undefined when calling showCoursesByThirdPartyCompanyId.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<AcademyResponse>(`${this.configuration.basePath}/academy/${encodeURIComponent(String(thirdPartyCompanyId))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Info for a specific user
     * @param userId The id of the user
     * @param withCpStatus add cp status to response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public showUserById(userId: number, withCpStatus?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserResponse>;
    public showUserById(userId: number, withCpStatus?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserResponse>>;
    public showUserById(userId: number, withCpStatus?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserResponse>>;
    public showUserById(userId: number, withCpStatus?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling showUserById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (withCpStatus !== undefined && withCpStatus !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>withCpStatus, 'with_cp_status');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send support request
     * @param supportRequest Support info to send
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public support(supportRequest: SupportRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public support(supportRequest: SupportRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public support(supportRequest: SupportRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public support(supportRequest: SupportRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (supportRequest === null || supportRequest === undefined) {
            throw new Error('Required parameter supportRequest was null or undefined when calling support.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/support`,
            supportRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update user
     * @param userId The id of the user
     * @param userRequest The user to update
     * @param withCpStatus add cp status to response
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUser(userId: number, userRequest: UserRequest, withCpStatus?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserResponse>;
    public updateUser(userId: number, userRequest: UserRequest, withCpStatus?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserResponse>>;
    public updateUser(userId: number, userRequest: UserRequest, withCpStatus?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserResponse>>;
    public updateUser(userId: number, userRequest: UserRequest, withCpStatus?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateUser.');
        }
        if (userRequest === null || userRequest === undefined) {
            throw new Error('Required parameter userRequest was null or undefined when calling updateUser.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (withCpStatus !== undefined && withCpStatus !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>withCpStatus, 'with_cp_status');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<UserResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}`,
            userRequest,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user alerts
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userAlerts(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserAlertsResponse>;
    public userAlerts(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserAlertsResponse>>;
    public userAlerts(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserAlertsResponse>>;
    public userAlerts(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userAlerts.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserAlertsResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/alerts`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certification courses
     * @param userId The id of the user
     * @param certificationId The id of the certification
     * @param courseType filter by course type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCertificationCourses(userId: number, certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>;
    public userCertificationCourses(userId: number, certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>>;
    public userCertificationCourses(userId: number, certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>>;
    public userCertificationCourses(userId: number, certificationId: number, courseType?: 'classroom' | 'online' | 'multicourse', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userCertificationCourses.');
        }
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling userCertificationCourses.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (courseType !== undefined && courseType !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>courseType, 'course_type');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationCoursesResponse | UserCertificationMulticoursesResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/certifications/${encodeURIComponent(String(certificationId))}/courses`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certification status
     * @param userId The id of the user
     * @param certificationId The id of the certification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCertificationStatus(userId: number, certificationId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationStatusResponse>;
    public userCertificationStatus(userId: number, certificationId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationStatusResponse>>;
    public userCertificationStatus(userId: number, certificationId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationStatusResponse>>;
    public userCertificationStatus(userId: number, certificationId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userCertificationStatus.');
        }
        if (certificationId === null || certificationId === undefined) {
            throw new Error('Required parameter certificationId was null or undefined when calling userCertificationStatus.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationStatusResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/certifications/${encodeURIComponent(String(certificationId))}/status`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certifications
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCertifications(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CertificationsResponse>;
    public userCertifications(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CertificationsResponse>>;
    public userCertifications(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CertificationsResponse>>;
    public userCertifications(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userCertifications.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CertificationsResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/certifications`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user certifications with status
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCertificationsWithStatus(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserCertificationsWithStatusResponse>;
    public userCertificationsWithStatus(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserCertificationsWithStatusResponse>>;
    public userCertificationsWithStatus(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserCertificationsWithStatusResponse>>;
    public userCertificationsWithStatus(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userCertificationsWithStatus.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserCertificationsWithStatusResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/certifications/status`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get children
     * @param userId The id of the user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userChildren(userId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserChildrenResponse>;
    public userChildren(userId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserChildrenResponse>>;
    public userChildren(userId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserChildrenResponse>>;
    public userChildren(userId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userChildren.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UserChildrenResponse>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/children`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get last consultants
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userLastConsultants(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UsersResponse>;
    public userLastConsultants(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UsersResponse>>;
    public userLastConsultants(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UsersResponse>>;
    public userLastConsultants(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UsersResponse>(`${this.configuration.basePath}/users/last-consultants`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get users project leaders
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userProjectLeaders(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UsersResponse>;
    public userProjectLeaders(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UsersResponse>>;
    public userProjectLeaders(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UsersResponse>>;
    public userProjectLeaders(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UsersResponse>(`${this.configuration.basePath}/users/project-leaders`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get users structure list
     * @param page The page to load
     * @param autocomplete filter by main string field
     * @param position filter by position
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userStructureList(page?: number, autocomplete?: string, position?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedUsersResponse>;
    public userStructureList(page?: number, autocomplete?: string, position?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedUsersResponse>>;
    public userStructureList(page?: number, autocomplete?: string, position?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedUsersResponse>>;
    public userStructureList(page?: number, autocomplete?: string, position?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (position !== undefined && position !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>position, 'position');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PaginatedUsersResponse>(`${this.configuration.basePath}/users/list-structure`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get users structure tree
     * @param network filter by network
     * @param user filter by user
     * @param onlyDirectUser filter by only_direct_user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userStructureTree(network?: number, user?: number, onlyDirectUser?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UsersResponse>;
    public userStructureTree(network?: number, user?: number, onlyDirectUser?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UsersResponse>>;
    public userStructureTree(network?: number, user?: number, onlyDirectUser?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UsersResponse>>;
    public userStructureTree(network?: number, user?: number, onlyDirectUser?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }
        if (user !== undefined && user !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>user, 'user');
        }
        if (onlyDirectUser !== undefined && onlyDirectUser !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>onlyDirectUser, 'only_direct_user');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UsersResponse>(`${this.configuration.basePath}/users/structure`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get supervisors
     * @param autocomplete filter by main string field
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userSupervisors(autocomplete?: string, network?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UsersResponse>;
    public userSupervisors(autocomplete?: string, network?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UsersResponse>>;
    public userSupervisors(autocomplete?: string, network?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UsersResponse>>;
    public userSupervisors(autocomplete?: string, network?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<UsersResponse>(`${this.configuration.basePath}/users/supervisors`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user teachers
     * @param page The page to load
     * @param autocomplete filter by main string field
     * @param segments filter by segments
     * @param network filter by network
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userTeachers(page?: number, autocomplete?: string, segments?: Array<number>, network?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedUsersResponse>;
    public userTeachers(page?: number, autocomplete?: string, segments?: Array<number>, network?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedUsersResponse>>;
    public userTeachers(page?: number, autocomplete?: string, segments?: Array<number>, network?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedUsersResponse>>;
    public userTeachers(page?: number, autocomplete?: string, segments?: Array<number>, network?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (autocomplete !== undefined && autocomplete !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>autocomplete, 'autocomplete');
        }
        if (segments) {
            segments.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'segments[]');
            })
        }
        if (network !== undefined && network !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>network, 'network');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (oauth) required
        credential = this.configuration.lookupCredential('oauth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<PaginatedUsersResponse>(`${this.configuration.basePath}/users/teachers`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
